import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=0ee6223b&scoped=true&"
import script from "./Btn.vue?vue&type=script&lang=ts&"
export * from "./Btn.vue?vue&type=script&lang=ts&"
import style0 from "./Btn.vue?vue&type=style&index=0&id=0ee6223b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee6223b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
